import React, { Component, useEffect, useState } from 'react'
import shortid from "shortid";
import { Link } from 'react-router-dom';
import "./LinkOnly.css"


const LinkOnly = ({ articleObj, param }) => {
  var content = articleObj;
    
    const [pathUrl, setPathUrl] = useState("")
    function scrollToView(id) {
      console.log("scroll-id",id)
      const idSplit = id.split("#")
      console.log("scroll-id-split",idSplit[1])
      const scroll = document.querySelector(`.${idSplit[1]}`);
      console.log("scroll", scroll)
      if (scroll != undefined && scroll != null) {
          scrollTop(scroll.offsetTop)
      }
  }

  const scrollTop = (top) => {
      var height = document.querySelector(`.${content.attributes.class}`).offsetHeight;
      var length = top - height
      window.scrollTo({
          top: parseInt(length),
          behavior: 'smooth'
      });
  };
    // useEffect(() => {
    //   var url= window.location.pathname;
    //   setPathUrl(url)
     
    // }, [])
    
    return (
<>
<div className={`${content.attributes.articleRendering} ${content.attributes.class}`}  dataType="LinkOnly" 
style={content.attributes.articlePadding ? { padding: `${content.attributes.articlePadding}` } : {}}>
  <div className={`${content.attributes.linkUrlCss}`}>
    {content.attributes.linkUrl && content.attributes.linkUrl.includes("http") ? 
    <a className={`${content.attributes.linkUrl && content.attributes.linkUrl==pathUrl?"selected-link":''} faq-menus `} href={content.attributes.linkUrl ? content.attributes.linkUrl : ""}>
       {content.attributes.linkName}
    </a> : content.attributes.linkUrl.includes("#") ? 
    <p className={`${content.attributes.linkUrl && content.attributes.linkUrl==pathUrl?"selected-link":''} faq-menus `} style={{ cursor: "pointer" }} onClick={() => scrollToView(content.attributes.linkUrl)}>
    {content.attributes.linkName}</p> :
      <Link className={`${content.attributes.linkUrl && content.attributes.linkUrl==pathUrl?"selected-link":''} faq-menus `} target={content.attributes.openLinkInNewTabYn === "true" ? "_blank" : ""} to={content.attributes.linkUrl ? content.attributes.linkUrl : ""}> 
        {content.attributes.linkName}
      </Link>
        }
  </div>
</div>
</>
    )
}

export default LinkOnly
